import React, { FC } from 'react';
import Section, { SectionProps, SectionType } from './Section';

const HORIZONTAL_ELLIPSIS = '\u2026';
const createSectionComponent =
  (type: SectionType): FC<React.PropsWithChildren<SectionProps>> =>
  (props) => <Section data-test={`asset-url-${type}`} type={type} {...props} />;

export const Prefix = createSectionComponent('prefix');
export const Kind = createSectionComponent('kind');
export const Signature = createSectionComponent('signature');
export const Transformation = createSectionComponent('transformation');
export const Version = createSectionComponent('version');
export const PublicId = createSectionComponent('publicId');
export const Ellipsis: FC<React.PropsWithChildren<Omit<SectionProps, 'type'>>> = () => (
  <Section data-test="asset-url-ellipsis" type="ellipsis">
    {HORIZONTAL_ELLIPSIS}/
  </Section>
);
